import * as React from "react";
import { CodeEditor } from "./../../group/identityMatcher/codeEditor";
import { Divider } from "antd";
import { formSet, formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { store } from "../../../store";

interface Props {
  provider: string;
}
export const ProviderPreInstallScript: React.FC<Props> = ({ provider }) => {
  const { id } = useCpFormContext();

  const value = useCpFormValue(`${provider}.preInstallScript`);

  return (
    <div className="mb-12">
      <Divider orientation={"left"} orientationMargin={0}>
        Pre-Install Script
      </Divider>
      <div>Optional shell script that will be run before K8S is installed</div>
      <CodeEditor
        language={"shell"}
        options={{ basicSetup: { autocompletion: false } }}
        value={value}
        setValue={(value) => formSetValue(id, `${provider}.preInstallScript` as any, value)}
        onChange={() => {
          const name = `${provider}.preInstallScript`;
          formSet(id, `fieldStates.${name}.modified`, true);

          const form = store.getState().form.instances[id];
          const onChangeCounter = form.meta.onChangeCounter;
          formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
        }}
        onFocus={() => {
          const name = `${provider}.preInstallScript`;
          formSet(id, `fieldStates.${name}.focused`, true);
          formSet(id, `fieldStates.${name}.visited`, true);
        }}
        onBlur={() => {
          const name = `${provider}.preInstallScript`;
          formSet(id, `fieldStates.${name}.focused`, false);
          formSet(id, `fieldStates.${name}.touched`, true);

          const form = store.getState().form.instances[id];
          const onBlurCounter = form.meta.onBlurCounter;
          formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
        }}
      />
    </div>
  );
};
